import * as actionTypes from '../actionType';
import Storage from './../../utils/Storage';
import studentListObject from './studentList';
import studentStatistics from './studentStatistics';
import defaultStudentListPayload from './defaultStudentListPayload';
import sendMessageState from './sendMessagesManage';
import interfaceLoading from './interfaceLoading';
import isOnline from './isOnline';
import classManage from './classManage';


// import testDefalutState from './testList';
const baseReducer = ({ baseState, type, callback }) => (state = baseState, action) => {
  switch (action.type) {
    case type:
      if (action.type === actionTypes.AXIOS_ENQUEUE) {
        if (!action.data) {
          state.forEach((cancel) => cancel());
          state = [];
        } else {
          state = [...state, action.data];
        }
        return [...state];
      }
      callback && callback(type, action.data);
      return action.data;
    default:
      return state;
  }
};

// 用户信息
const user = baseReducer({
  baseState: {},
  type: actionTypes.USER,
});
// 菜

// 权限列表
const permissions = baseReducer({
  baseState: [],
  type: actionTypes.PERMISSIONS,
});

// 请求取消
const axiosCancel = baseReducer({
  baseState: [],
  type: actionTypes.AXIOS_ENQUEUE,
});
export default {
  user,
  permissions,
  axiosCancel,
  ...studentListObject,
  ...studentStatistics,
  ...defaultStudentListPayload,
  // ...testDefalutState,
  ...sendMessageState,
  ...interfaceLoading,
  ...isOnline,
  ...classManage

};
